import React from "react";
import api from "../../Auth/Api";
import { Button } from "@mui/material";
import { PageContainer, SectionHeader, formatDate, preWrap } from "../../Layout/Common";
import PagedTable from "../../Layout/PagedTable";
import { subscribePoll } from "../../Layout/Poller";
import DecisionDetailsDialog from "./DecisionDetailsDialog";

const PAGE = 20;

// Design-decision log (every status); Details opens the rationale + alternatives. Approvals happen on Human Review.
export default class DecisionsPage extends React.Component {
    state = { decisions: [], total: 0, page: 1, details: null };
    componentDidMount() { this.load(); this.unsub = subscribePoll(this.load, 10000); }
    componentWillUnmount() { if (this.unsub) this.unsub(); }
    load = async () => {
        if (this.loading) { this.pending = true; return true; }
        this.loading = true;
        try {
            const r = await api.development("Loading decisions", ["decisions"], { silent: true, payload: { skip: (this.state.page - 1) * PAGE, limit: PAGE } });
            if (r && r.decisions) this.setState({ decisions: r.decisions, total: r.total || 0 });
            return true;
        } catch { return false; }
        finally {
            this.loading = false;
            if (this.pending) { this.pending = false; this.load(); }
        }
    };
    setPage = (p) => this.setState({ page: p }, this.load);
    render() {
        const { decisions, total, page, details } = this.state;
        return (
            <PageContainer maxWidth={1000}>
                <SectionHeader title="Design Decisions" />
                <PagedTable
                    rows={decisions} total={total} page={page} pageSize={PAGE} onPage={this.setPage}
                    columns={[
                        { id: "createdDate", label: "Date", sx: { whiteSpace: "nowrap" }, render: d => formatDate(d.createdDate) },
                        { id: "author", label: "Author" },
                        { id: "kind", label: "Kind" },
                        { id: "summary", label: "Summary", width: "50%", sx: preWrap },
                        { id: "status", label: "Status" },
                        { id: "approvedBy", label: "By" },
                        { id: "actions", label: "", width: "1%", render: d => <Button size="small" onClick={() => this.setState({ details: d })}>Details</Button> },
                    ]}
                    getRowKey={d => d.id}
                />
                <DecisionDetailsDialog decision={details} onClose={() => this.setState({ details: null })} />
            </PageContainer>
        );
    }
}
